<section class="setup" aria-labelledby="environment-setup-title">
  <header><div><h2 id="environment-setup-title">Environment setup</h2>
    <p>Initialize missing seed data and repair seed-owned records.</p></div>
    <button uiButton type="button" (click)="refresh()" [disabled]="!canSeed() || loading()">Refresh status</button>
  </header>
  <p *ngIf="error()" class="error" role="alert">{{ error() }}</p>
  <ng-container *ngIf="canSeed() && !accessDenied(); else noPermission">
    <p *ngIf="loading() && !status()" role="status">Loading environment setup…</p>
    <ng-container *ngIf="status() as current">
      <dl><div><dt>Environment</dt><dd>{{ current.environment }}</dd></div>
        <div><dt>Data profile</dt><dd>{{ current.profile }}</dd></div></dl>
      <p *ngIf="!current.available" role="status">{{ current.unavailableReason }}</p>
      <p *ngIf="enabledPhases()"><strong>Enabled phases:</strong> {{ enabledPhases() }}</p>
      <div class="actions">
        <button uiButton type="button" (click)="run()" [disabled]="!canRun()">{{ active() ? 'Seed in progress' : 'Run seed' }}</button>
        <span *ngIf="active()" role="status" aria-live="polite">{{ label(current.run!.state) }}. You can leave this page and return to check progress.</span>
      </div>
      <section *ngIf="current.run as run; else neverRun" aria-label="Latest seed run">
        <h3>Latest run · {{ label(run.state) }}</h3>
        <p>Run reference: <code>{{ run.id }}</code></p>
        <dl><div><dt>Requested by</dt><dd>{{ run.requestedByName }}</dd></div>
          <div><dt>Requested</dt><dd>{{ run.requestedAtUtc | date:'medium' }}</dd></div>
          <div *ngIf="run.startedAtUtc"><dt>Started</dt><dd>{{ run.startedAtUtc | date:'medium' }}</dd></div>
          <div *ngIf="run.completedAtUtc"><dt>Finished</dt><dd>{{ run.completedAtUtc | date:'medium' }}</dd></div></dl>
        <p *ngIf="run.error" class="error" role="alert">{{ run.error }}</p>
        <p *ngIf="run.state === 'failed'">Review the phase results, correct the issue, then use Run seed to retry explicitly.</p>
      </section>
      <ng-template #neverRun><p>No seed run has been recorded for this environment.</p></ng-template>
      <table><caption>Seed phases</caption><thead><tr><th scope="col">Phase</th><th scope="col">Status</th><th scope="col">Result</th></tr></thead>
        <tbody><tr *ngFor="let phase of phases()"><th scope="row">{{ phase.name }}</th><td>{{ label(phase.state) }}</td><td>{{ phase.message }}</td></tr></tbody></table>
    </ng-container>
  </ng-container>
  <ng-template #noPermission><p>You need environment setup permission to view or run seeding.</p></ng-template>
</section>
